import AdditionalIncomeService from './AdditionalIncomeService';
import ApiService from './ApiService';
import BuyerInfoService from './BuyerInfoService';
import CallbackService from './CallbackService';
import CreditorService from './CreditorService';
import DealInfoService from './DealInfoService';
import DialogService from './DialogService';
import DocumentService from './DocumentService';
import EmploymentInfoService from './EmploymentInfoService';
import NavigationService from './NavigationService';
import StipsService from './StipsService';
import ToastService from './ToastService';
import UIService from './UIService';
import VehicleInfoService from './VehicleInfoService';

const registerServices = store => {
    ToastService.init(store);
    BuyerInfoService.init(store);
    DealInfoService.init(store);
    DocumentService.init(store);
    NavigationService.init(store);
    EmploymentInfoService.init(store);
    VehicleInfoService.init(store);
    AdditionalIncomeService.init(store);
    UIService.init(store);
    ApiService.init(store);
    CallbackService.init(store);
    CreditorService.init(store);
    StipsService.init(store);
    DialogService.init(store);
};

export default registerServices;
